import React from "react";
import {
    TableBody,
    TableRow,
    TableCell,
    Typography,
    CircularProgress,
} from "@mui/material";
import { useLanguage } from '../../../../context/LanguageContext';
import ListTableRow from './ListTableRow';
import { ImportedList, TYPE_COLORS, TYPE_TRANSLATION_KEYS, getListType } from '../types';

interface ListTableBodyProps {
    lists: ImportedList[];
    loading: boolean;
    selectedRows: (string | number)[];
    onSelectRow: (id: string | number) => void;
    onVisualise: (list: ImportedList) => void;
    onDelete: (list: ImportedList) => void;
}

const ListTableBody = ({
    lists,
    loading,
    selectedRows,
    onSelectRow,
    onVisualise,
    onDelete,
}: ListTableBodyProps) => {
    const { t } = useLanguage();

    if (loading) {
        return (
            <TableBody>
                <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
                        <CircularProgress />
                    </TableCell>
                </TableRow>
            </TableBody>
        );
    }

    if (lists.length === 0) {
        return (
            <TableBody>
                <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
                        <Typography color="text.secondary">
                            {t("pages.clients.importList.noLists")}
                        </Typography>
                    </TableCell>
                </TableRow>
            </TableBody>
        );
    }

    return (
        <TableBody>
            {lists.map(list => {
                const listType = getListType(list);
                return (
                    <ListTableRow
                        key={list.LIST_ID}
                        list={list}
                        isSelected={selectedRows.includes(list.LIST_ID)}
                        typeColor={TYPE_COLORS[listType] || "primary"}
                        typeTranslationKey={TYPE_TRANSLATION_KEYS[listType] || 'person'}
                        onSelect={onSelectRow}
                        onVisualise={onVisualise}
                        onDelete={onDelete}
                    />
                );
            })}
        </TableBody>
    );
};

export default ListTableBody;
